import { render } from "./TheButtonInTable.vue?vue&type=template&id=968099be"
import script from "./TheButtonInTable.vue?vue&type=script&lang=js"
export * from "./TheButtonInTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__